import { isNonEmptyString } from '@sniptt/guards';
import { isDefined } from 'app-shared/utils';
import { Field, Input } from 'app-ui/primitives/input';
import {
  type Control,
  Controller,
  type FieldPath,
  type FieldValues,
} from 'react-hook-form';

type SettingsTextFieldProps<TFormValues extends FieldValues> = {
  control: Control<TFormValues>;
  name: FieldPath<TFormValues>;
  label: string;
  autoComplete?: string;
  // Shown under the field, such as why it can't be edited.
  description?: string;
  readOnly?: boolean;
};

// A labelled text input bound to react-hook-form, showing the validation
// message of its field.
export const SettingsTextField = <TFormValues extends FieldValues>({
  control,
  name,
  label,
  autoComplete,
  description,
  readOnly,
}: SettingsTextFieldProps<TFormValues>) => (
  <Controller
    control={control}
    name={name}
    render={({ field, fieldState }) => (
      <Field.Root invalid={isDefined(fieldState.error)}>
        <Field.Label>{label}</Field.Label>
        <Input
          ref={field.ref}
          name={field.name}
          value={field.value}
          autoComplete={autoComplete}
          readOnly={readOnly}
          onValueChange={field.onChange}
          onBlur={field.onBlur}
        />
        {isNonEmptyString(description) && (
          <Field.Description>{description}</Field.Description>
        )}
        <Field.Error match={isDefined(fieldState.error)}>
          {fieldState.error?.message}
        </Field.Error>
      </Field.Root>
    )}
  />
);
